module.exports = __webpack_public_path__ + "img/product-preview-10.8ab9818.png";